import { render } from "./GerenciarQuadrasView.vue?vue&type=template&id=e225eafc&scoped=true"
import script from "./GerenciarQuadrasView.vue?vue&type=script&lang=js"
export * from "./GerenciarQuadrasView.vue?vue&type=script&lang=js"

import "./GerenciarQuadrasView.vue?vue&type=style&index=0&id=e225eafc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e225eafc"]])

export default __exports__